import type { PropsWithChildren } from 'react'
import type { ItemSelectionProps } from './types'
import { horizontalGap, Icon, tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'

import { styled } from 'styled-components'

import { useItemContext } from './context'

const Wrapper = styled.div`
  align-items: center;
  color: ${tk('color_semantic_text_subdued')};
  display: flex;
  flex-direction: row;
  overflow: hidden;

  ${horizontalGap('spacing_2xs')}
`

const SelectionText = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const MobileSelectionText = styled(SelectionText)`
  @media ${tk('mq_tablet')} {
    display: none;
  }
`

const TabletSelectionText = styled(SelectionText)`
  display: none;

  @media ${tk('mq_tablet')} {
    display: block;
  }
`

export function IconItem({
  selectionFormattedText,
  compactSelectionFormattedText,
  ...rest
}: PropsWithChildren<ItemSelectionProps>) {
  const { icon } = useItemContext()

  if (!selectionFormattedText && !compactSelectionFormattedText)
    return null

  return (
    <Wrapper {...rest}>
      <Icon glyph={icon} size="sm" />
      <MobileSelectionText $variant="body-xs">{compactSelectionFormattedText}</MobileSelectionText>
      <TabletSelectionText $variant="body-xs">{selectionFormattedText}</TabletSelectionText>
    </Wrapper>
  )
}
